// removed by extract-text-webpack-plugin
module.exports = {"aws-package":"ipselector-module__aws-package___2SCiL","addon-label":"ipselector-module__addon-label___88qGb","addon-cost":"ipselector-module__addon-cost___3KmFk","option":"ipselector-module__option___248KB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ipselector.module.scss
// module id = 133
// module chunks = 1